import React, { useState } from 'react';
import { TriangleAlert } from 'lucide-react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from 'components/shadcn/ui/dialog';
import { Button } from 'components/shadcn/ui/button';
import { LoadingSpinner } from 'components/shadcn/ui/loadingSpinner';

const UpgradeWarning = ({ open, close, startFirmwareUpgrade }) => {
    const [loading, setLoading] = useState(false);

    const handleContinue = async () => {
        setLoading(true);
        await startFirmwareUpgrade();
        setLoading(false);
    };

    return (
        <Dialog open={open} onOpenChange={close}>
            <DialogContent className="max-w-80">
                <DialogHeader>
                    <div className="flex items-center justify-center gap-2">
                        <TriangleAlert className="h-5 w-5 text-yellow-500" />
                        <DialogTitle className="uppercase">
                            Firmware Upgrade
                        </DialogTitle>
                        <TriangleAlert className="h-5 w-5 text-yellow-500" />
                    </div>
                    <DialogDescription className="pt-2 text-secondary">
                        Battery will restart multiple times during upgrade
                        process. Please do not interrupt and wait till upgrade
                        is complete.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="flex justify-around sm:justify-around">
                    <Button
                        variant="outline"
                        onClick={handleContinue}
                        disabled={loading}
                        className="min-w-[100px]"
                    >
                        {loading ? (
                            <LoadingSpinner className="h-4 w-4 border-2 border-t-2" />
                        ) : (
                            'Continue'
                        )}
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={close}
                        disabled={loading}
                        className="min-w-[100px]"
                    >
                        Cancel
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default UpgradeWarning;
